import { FC, ReactNode } from 'react';
import { MagicBoxRow as MagicBoxRowLib, MagicBoxRowProps } from '@brg/ui';
import { AppTester } from 'supporting';

export const MagicBoxRow: FC<Omit<MagicBoxRowProps, 'isGeo' | 'isContinuumSite'>> = (props) => {
    const isGeo = AppTester.isGeograffee() && !AppTester.isGeoDafes();
    const isContinuumSite = AppTester.isContinuumSite();

    return <MagicBoxRowLib {...props} isGeo={isGeo} isContinuumSite={isContinuumSite} />;
};

export type { MagicBoxRowProps };

import { FC, ReactNode } from 'react';
import { MagicBoxRow as MagicBoxRowLib, MagicBoxRowProps } from '@brg/ui';
import { AppTester } from 'supporting';

export const MagicBoxRow: FC<Omit<MagicBoxRowProps, 'isGeo' | 'isContinuumSite'>> = (props) => {
    const isGeo = AppTester.isGeograffee() && !AppTester.isGeoDafes();
    const isContinuumSite = AppTester.isContinuumSite();

    return <MagicBoxRowLib {...props} isGeo={isGeo} isContinuumSite={isContinuumSite} />;
};

export type { MagicBoxRowProps };

